<!--
  创建时间：2023/7/28 17:10
  创建人：toyehuang
  文件描述：LayoutFooter
-->

<template>
  <footer class="layout-footer">
    <div class="footer-container fc99">
      <div class="def-w f-b-c">
        <div class="row">
          <dl>
            <dt>联系我们</dt>
            <dd>服务热线：{{ info.technicalHotline }}({{ info.workTime }})</dd>
            <dd>客服邮箱：{{ info.email }}({{ info.workTime }})</dd>
            <dd>办公地址：{{ info.address }}</dd>
          </dl>
          <dl>
            <dt>技术支持</dt>
            <dd>技术支持：江苏易交易信息科技有限公司</dd>
            <dd>电话：400-828-9082</dd>
            <dd>地址：江苏省常州市钟楼区玉龙南路280号常州大数据产业园4号楼21层</dd>
          </dl>
        </div>
        <div class="wx-qrcode">
          <img :src="info.wechatLogo" alt="黑龙江交易集团有限公司">
          <p>关注微信公众号</p>
        </div>
        <div class="wx-qrcode">
          <img src="@/assets/images/home/jttsewm.png" alt="黑龙江交易集团有限公司业务投诉二维码" style="margin-top: 20px;">
          <p>黑龙江交易集团</p>
          <p>业务投诉二维码</p>
        </div>
        <!-- <div class="jbts-qrcode">
          <img src="@/assets/images/home/jbts.png" alt="黑龙江交易集团有限公司">
        </div> -->
      </div>
    </div>
    <div class="site-info fc99 bgff">
      版权信息：Copyright 2011 All Rights Reserved 牡丹江联合产权交易有限公司 版权所有
      <a href="https://beian.miit.gov.cn/#/Integrated/index" style="color: #999;text-decoration: underline;" target="_blank" rel="noopener noreferrer">
        黑ICP备2025043415号
      </a>
    </div>
  </footer>
</template>

<script>
import { mapGetters } from "vuex";
import {
  getConstantDic,
  INFO_TYPE_OPTIONS,
  PROJECT_TYPE_OPTIONS,
  SELECT_OPTION_CONFIG
} from "@/utils/constant";
export default {
  name: "LayoutFooter",
  // components: { Link },
  data() {
    return {
      info: {},
      projectTypeOpt: getConstantDic(PROJECT_TYPE_OPTIONS).filter(
        (item) =>
          item[SELECT_OPTION_CONFIG.CODE] !==
          PROJECT_TYPE_OPTIONS.ALL[SELECT_OPTION_CONFIG.CODE]
      ),
      infoTypeOpt: getConstantDic(INFO_TYPE_OPTIONS).filter(
        (item) =>
          item[SELECT_OPTION_CONFIG.CODE] !==
          INFO_TYPE_OPTIONS.ALL[SELECT_OPTION_CONFIG.CODE]
      ),
      SELECT_OPTION_CONFIG
    };
  },
  // 监听属性 类似于data概念
  computed: {
    ...mapGetters(["site"])
  },
  // 生命周期 - 创建完成（可以访问当前this实例）
  created() {
    this.info = this.site || {};
  },
  // 生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {},
  // 方法集合
  methods: {
  }
};
</script>

<style scoped lang="scss">
.layout-footer {
  .footer-container{
    width: 100%;
    height: 300px;
    padding-top: 65px;
    background-color: #333;
    dl{
      min-width: 450px;
      padding-right: 20px;
      line-height: 36px;
      dt{
        color: #fff;
        font-size: 20px;
        font-weight: bold;
      }
      dd{
        font-size: 14px;
      }
    }
    .wx-qrcode{
      text-align: center;
      font-size: 14px;
      img{
        width: 100px;
        height: 100px;
      }
    }
    .jbts-qrcode{
      img{
        width: 118px;
        height: 123px;
      }

    }
  }
  .site-info{
    width: 100%;
    height: 80px;
    line-height: 80px;
    text-align: center;
    font-size: 12px;
  }
}
</style>
